import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const WatchChangedConfig: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <>
      <Toggle
        label={t('settings.security.watch_changed_config.title')}
        description={t('settings.security.watch_changed_config.description')}
        value={settings.hardwareChanges}
        onChange={(value: string) => {
          setSetting({
            alias: ESettingsAliases.HARDWARE_CHANGED,
            value: value ? '1' : '0',
          });
        }}
        variant="secondary"
        emptyBg
      />
    </>
  );
};
